import React from 'react';

import { TIconType } from '../interface';

const InterlinkIcon: TIconType = () => {
	return (
		<svg
			fill='none'
			height='6'
			viewBox='0 0 12 6'
			width='12'
		>
			<path
				d='M1.27502 3.02507C1.27502 2.02757 2.08585 1.21673 3.08335 1.21673H5.41669V0.108398H3.08335C1.47335 0.108398 0.166687 1.41507 0.166687 3.02507C0.166687 4.63507 1.47335 5.94173 3.08335 5.94173H5.41669V4.8334H3.08335C2.08585 4.8334 1.27502 4.02257 1.27502 3.02507ZM3.66669 3.6084H8.33335V2.44173H3.66669V3.6084ZM8.91669 0.108398H6.58335V1.21673H8.91669C9.91419 1.21673 10.725 2.02757 10.725 3.02507C10.725 4.02257 9.91419 4.8334 8.91669 4.8334H6.58335V5.94173H8.91669C10.5267 5.94173 11.8334 4.63507 11.8334 3.02507C11.8334 1.41507 10.5267 0.108398 8.91669 0.108398Z'
				fill='#CCCCCC'
			/>
		</svg>
	);
};

export default InterlinkIcon;
